import { LoadingPanel } from './ui/index.js'

function LoadingState({ label = '正在加载' }) {
  return <LoadingPanel label={label} />
}

export default LoadingState
